import React from 'react';

function IconEarth() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fillRule="evenodd"
        d="M11.326 15.575c-.754 1.592-1.5 1.925-1.826 1.925-.326 0-1.072-.333-1.826-1.925a10.57 10.57 0 01-.627-1.726A19.62 19.62 0 009.5 14c.848 0 1.67-.053 2.453-.151a10.573 10.573 0 01-.627 1.726zm.96-3.289c-.863.137-1.8.214-2.786.214s-1.923-.077-2.786-.214c-.137-.863-.214-1.8-.214-2.786s.077-1.923.214-2.786c.863-.137 1.8-.214 2.786-.214s1.923.077 2.786.214c.137.863.214 1.8.214 2.786s-.077 1.923-.214 2.786zm1.282 1.282c-.305 1.356-.758 2.535-1.314 3.445a8.023 8.023 0 004.76-4.759c-.91.556-2.09 1.009-3.446 1.314zM19 9.5a9.5 9.5 0 10-19 0 9.5 9.5 0 0019 0zm-17.5 0v.002c.001.326.336 1.072 1.925 1.824.502.239 1.083.45 1.726.627A19.627 19.627 0 015 9.5c0-.848.053-1.67.151-2.453a10.57 10.57 0 00-1.726.627C1.834 8.427 1.5 9.174 1.5 9.5zm3.932-4.068c-1.356.305-2.535.757-3.445 1.314a8.023 8.023 0 014.759-4.76c-.557.91-1.009 2.09-1.314 3.446zm1.615-.28a10.57 10.57 0 01.627-1.727C8.428 1.833 9.174 1.5 9.5 1.5c.326 0 1.072.333 1.826 1.925.239.502.45 1.083.627 1.726A19.627 19.627 0 009.5 5c-.848 0-1.67.053-2.453.151zm6.52.28c-.304-1.356-.757-2.535-1.313-3.445a8.023 8.023 0 014.76 4.759c-.91-.557-2.09-1.009-3.446-1.314zm.282 1.615a10.57 10.57 0 011.726.627c1.592.754 1.925 1.5 1.925 1.826 0 .326-.333 1.072-1.925 1.826-.502.239-1.083.45-1.726.627.098-.783.151-1.605.151-2.453 0-.848-.053-1.67-.151-2.453zm-8.417 6.52c-1.356-.304-2.535-.757-3.445-1.313a8.023 8.023 0 004.759 4.76c-.557-.91-1.009-2.09-1.314-3.446z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconEarth;
